/* eslint-disable react/jsx-key */
import { useEffect, useState } from 'react';
import Footer from '@/components/Layout/Footer/Footer';
import room from '@/assets/seeker.png';
import seeker from '@/assets/sale1.png';
import banner from '@/assets/sales.png';
import loc from '@/assets/loc-add.png';
import town from '@/assets/town1.png';
import town1 from '@/assets/town1.png';
import town2 from '@/assets/town2.png';
import info from '@/assets/over.png';
import arrow from '@/assets/btn-arrow.png';
import { ContentLayout } from '@/components/Layout';
import { Button } from '@/components/Elements';
import i18next from 'i18next';
import turn from '@/assets/turn.png';
import temp from '@/assets/temp.png';
import shop from '@/assets/shops.png';
import doc from '@/assets/document.png';
import cnt from '@/assets/cnt.png';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import Header, { HeaderType } from '@/components/Layout/Header/Header';
import { useBusinessSaleDetails } from '@/api/bussinessForSale/getBusinessfroSaleDetail';
import { useNavigate, useParams } from 'react-router-dom';
import PropertyDetail from '@/components/Elements/Loader/PropertyDetail';
import { getBFS } from '@/api/bussinessForSale/getBFS';
import FsImageOpner from '@/components/FsImageOpner/FsImageOpner';
import { useBusinessDetails } from '@/api/commonDetail/getBusinessDetail';
import GoogleMapReact from 'google-map-react';
import chat1 from '@/assets/chat2.png';
import { createChat } from '@/api/Chat/createChat';
import { useAuth } from '@/lib/auth';
import { useNotificationStore } from '@/stores/notifications';
import { SendMessage } from '../../SendMessage/sendMessage';
import storage from '@/utils/storage';
import { formatPrice } from '@/utils/format';
import { formatAmount } from '../../NewHomePage/HomePage';

export const BusinessForSaleDetail = () => {
  const AnyReactComponent = ({ lat, lng, text }: { lat: any; lng: any; text: any }) => (
    <div>{text}</div>
  );

  const { id }: any = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const localSymbol = storage.getSymbol();
  const localAmount = storage.getAmount();

  const [toggler, setToggler] = useState<boolean>(false);
  const [pics, setPics] = useState<string[]>([]);

  const [img1, setImg1] = useState();
  const [img2, setImg2] = useState();
  const [img3, setImg3] = useState();
  const [iLat, setiLat] = useState<number>();
  const [iLong, setiLong] = useState<number>();
  const { data, isLoading, refetch } = useBusinessDetails({
    id: id ?? '2',
    customer_id: user?.customer_id ?? '',
  });
  const business = data?.data;

  useEffect(() => {
    if (business) {
      const parsed_data = business?.image_data ?? business?.image;
      setImg1(parsed_data[0]);
      setImg2(parsed_data[1]);
      setImg3(parsed_data[2]);

      const parsedLat = parseFloat(business.latitude);
      const parsedLong = parseFloat(business.longitude);

      if (!isNaN(parsedLat) && !isNaN(parsedLong)) {
        setiLat(parsedLat);
        setiLong(parsedLong);
      } else {
        console.log('Invalid latitude or longitude values');
      }
    }
  }, [business]);

  // useEffect(() => {
  //   eval(business?.image_data)?.map((val: string) => {
  //     setPics((item) => [...item, val]);
  //   });
  // }, [isLoading]);

  useEffect(() => {
    const video: string = business?.videos ?? '';
    setPics([video]);
    const images = eval(business?.image_data);
    if (images && Array.isArray(images)) {
      images.forEach((val: string) => {
        setPics((prevPics) => [...prevPics, val]);
      });
    }
  }, [isLoading]);

  const handleChat = async () => {
    try {
      if (!user) {
        useNotificationStore.getState().addNotification({
          title: 'Login',
          type: 'info',
          message: 'Need to Login first!',
        });
        navigate('/auth/login-user');
        return;
      }
      const res: any = await createChat(business?.customer_id);
      navigate(`/user/chat?id=${business?.customer_id}&sid=${res?.twilio_channel_sid}`);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      {isLoading ? (
        <PropertyDetail />
      ) : (
        <ContentLayout title={i18next.t('Business For Sale Detail')}>
          <FsImageOpner pics={pics} index={0} show={toggler} />

          <Header type={HeaderType.LANDING} />
          <section className="agency-tabssec sale-details">
            <div className="container">
              {business?.customer_id !== user?.customer_id && (
                <div className="col-12 d-flex justify-content-end pb-4">
                  <Button
                    className="black-btn bg-black"
                    size="sm"
                    // disabled={business?.is_requested}
                    onClick={(e) => {
                      if (!user) {
                        useNotificationStore.getState().addNotification({
                          title: 'Login',
                          type: 'info',
                          message: 'Need to Login first!',
                        });
                        navigate('/auth/login-user');
                        return;
                      }
                      setShow(true);
                    }}
                  >
                    Send Message
                  </Button>
                </div>
              )}
              <div className="business-deals-box relative d-flex flex-wrap ">
                <div className="busines-deal-content">
                  <h2 className="f-50 font-semibold text-black mb-2">{business?.short_title} </h2>
                  <div className="row">
                    <div className="col-12 col-md-7 col-xl-8">
                      <div className="relative sales-banner-bx">
                        <div className="great-income">
                          <p className="f-18">Great income potential on several fronts.</p>
                          <h3 className="f-30 semi-bold">
                            {localSymbol} {formatAmount(formatPrice(business?.cost * localAmount))}
                          </h3>
                        </div>
                        <img src={img1} className="sales-banner-img" />
                        <div className="town-content shadow bg-white p-2 rounded-10">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="town-details  town-bg p-2">
                                <div className="town-img">
                                  <img src={town1} alt="pay1" />
                                </div>
                                <div className="town-text">
                                  <h6 className="mb-0 light-color f-13">Concept:</h6>
                                  <p className="mb-0 text-black f-14">
                                    {business?.operation_concept}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="town-details  town-bg p-2">
                                <div className="town-img">
                                  <img src={town2} alt="pay1" />
                                </div>
                                <div className="town-text">
                                  <h6 className="mb-0 light-color f-13">Opening hours:</h6>
                                  <p className="mb-0 text-black f-14">
                                    {business?.operation_opening_hours}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-5 col-xl-4">
                      <div className="white-card prof-box">
                        <p className="f-14 p-2">{business?.description}</p>
                        <img src={img2} className="profess-icon" />
                      </div>
                      <div className="location-boxes-cnt">
                        <div className="loc-first-box d-flex align-items-start gap-2 ">
                          <img src={town2} className="locn-ico" />
                          <div className="locn-icons">
                            <h5>Location: </h5>
                            <h4 className="f-20 semi-bold">
                              {business?.floor ?? ''} {business?.floor && ','}{' '}
                              {business?.landmark ?? ''}
                              {business?.landmark && ','}
                              {business?.location}
                            </h4>
                          </div>
                        </div>
                        <div className="loc-first-box d-flex align-items-start  gap-2 mt-3">
                          <img src={turn} className="locn-ico" />
                          <div className="locn-icons">
                            <h5>Turnover: </h5>
                            <h4 className="f-20 semi-bold">
                              {localSymbol}{' '}
                              {formatAmount(formatPrice(business?.total_turnover * localAmount)) ??
                                'NA'}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="business-right-box">
                  <img src={img3} className="sale-seeker w-100 busi-sale-img" />

                  <div className="business-ale-bx mt-3">
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <img src={img1} className="sales-seeker w-100" />
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="relative deals-banenr">
                          <img src={img2} className="sales-seeker w-100" />
                          <div className="banner-abd busin">
                            <Button
                              className="white-btn bg-white rounded-full"
                              onClick={() => {
                                setToggler(!toggler);
                              }}
                            >
                              <span className="d-flex gap-1">
                                View All <img src={arrow} className="deal-arw" />
                              </span>
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row financial-box mt-4">
                <div className="col-12 col-lg-5">
                  <div className="white-box finance-wrap">
                    <h5 className="dark">Financial Information</h5>
                    <hr />
                    <div
                      className="w-full rounded-full"
                      style={{
                        backgroundColor: business?.percentage_invested > 90 ? '#90EE90' : '#ec97a6',
                      }}
                    >
                      <div
                        className=" h-2.5 rounded-full"
                        style={{
                          backgroundColor:
                            business?.percentage_invested > 90 ? '#006400' : '#D9304E',
                          width: `${business?.percentage_invested}%`,
                          height: '10px',
                          zIndex: 10,
                        }}
                      ></div>
                    </div>
                    <div className="flex justify-between items-center my-3">
                      <div className="text-black">
                        {localSymbol}{' '}
                        {formatAmount(
                          formatPrice(
                            business?.total_investment
                              ? business?.total_investment * localAmount
                              : 0
                          )
                        )}
                      </div>

                      <div className="text-black">
                        {localSymbol}
                        {'  '}
                        {formatAmount(formatPrice(business?.cost * localAmount))}
                      </div>
                    </div>
                    <div className="financeinfo-bs d-flex flex-wrap justify-between">
                      <div className="finance-bx-one">
                        <p className="semi-bold text-black f-14">
                          {localSymbol}
                          {formatAmount(formatPrice(business?.turnover_last_year * localAmount))}
                        </p>
                        <p className="f-13">Turnover 2023</p>
                      </div>
                      <div className="finance-bx-one">
                        <p className="semi-bold text-black f-14">{business?.salary_percentage}%</p>
                        <p className="f-13">Salary Percentage</p>
                      </div>
                      <div className="finance-bx-one">
                        <p className="semi-bold text-black f-14">
                          {localSymbol} {formatAmount(business?.other_operating_cost)}
                        </p>
                        <p className="f-13">Other Operating Costs</p>
                      </div>
                      <div className="finance-bx-one">
                        <p className="semi-bold text-black f-14">{business?.established_year}</p>
                        <p className="f-13">Established Year</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-7">
                  <div className="white-card white-box finance-wrap busi-descri">
                    <p className="f-14">{business?.description}</p>
                  </div>
                </div>
              </div>

              <div className="row documents-sales mt-4">
                <div className="col-12 col-md-9">
                  <div className="white-box finance-wrap rent">
                    <h5 className="pb-4 dark">Rent/The Locations </h5>
                    <div className="rent-locations d-flex flex-wrap">
                      <div className="shop-boxes text-center">
                        <span className="shop-image">
                          <img src={shop} />
                        </span>
                        <p className="py-2 f-13">Reason for sale</p>
                        <h5 className="dark">{business?.reason_for_sale}</h5>
                      </div>
                      <div className="shop-boxes text-center">
                        <span className="shop-image">
                          <img src={shop} />
                        </span>
                        <p className="py-2 f-13">Online</p>
                        <a href={business?.website_link} className="dark" target="_blank">
                          Link
                        </a>
                      </div>
                      <div className="shop-boxes text-center">
                        <span className="shop-image">
                          <img src={shop} />
                        </span>
                        <p className="py-2 f-13">Number of employees</p>
                        <h5 className="dark">{formatAmount(business?.number_of_employes)}</h5>
                      </div>
                      <div className="shop-boxes text-center">
                        <span className="shop-image">
                          <img src={shop} />
                        </span>
                        <p className="py-2 f-13">Area</p>
                        <h5 className="dark">{formatAmount(business?.area)}</h5>
                      </div>
                      <div className="shop-boxes text-center">
                        <span className="shop-image">
                          <img src={shop} />
                        </span>
                        <p className="py-2 f-13">Rent</p>
                        <h5 className="dark">
                          {' '}
                          {localSymbol} {formatAmount(formatPrice(business?.rent * localAmount))}
                          /month
                        </h5>
                      </div>
                      <div className="shop-boxes text-center">
                        <span className="shop-image">
                          <img src={shop} />
                        </span>
                        <p className="py-2 f-13">Terms of Lease</p>
                        <h5 className="dark">{business?.term_of_lease}</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className="white-box finance-wrap dcs">
                    <h5 className="pb-2 dark">Documents </h5>
                    {business?.document?.map((i: string, index: number) => {
                      return (
                        <div className="team-data-col d-flex gap-3 align-items-center my-3">
                          <img src={doc} className="team-doc-icon" alt="" />
                          <div className="team-col-cont">
                            <p className="f-14 text-black">
                              <a href={i} target="_blank" className="mx-2">
                                Document {index + 1}
                              </a>
                            </p>
                            {/* <p className="f-13">
                          <span>23 Oct, 2023</span> <span className="ms-2">2MB</span>
                        </p> */}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              <div className="deals-sales white-box finance-wrap mt-4">
                <h5 className="dark">Details</h5>
                <p className="f-13">{business?.details}</p>

                <div className="sales-acc">
                  <Accordion className="info-acc">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      <h6 className="mb-0  semi-bold text-black">Servies</h6>
                    </AccordionSummary>
                    <AccordionDetails>
                      <p className="f-13 text-black">{business?.service}</p>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion className="info-acc">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel2-content"
                      id="panel2-header"
                    >
                      <h6 className="mb-0  semi-bold text-black">Operation</h6>
                    </AccordionSummary>
                    <AccordionDetails>
                      <p className="f-13 text-black">{business?.operations}</p>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion className="info-acc">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel3-content"
                      id="panel3-header"
                    >
                      <h6 className="mb-0  semi-bold text-black">Marketing initiatives</h6>
                    </AccordionSummary>
                    <AccordionDetails>
                      <p className="f-13 text-black">{business?.market_initatives}</p>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion className="info-acc">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel3-content"
                      id="panel3-header"
                    >
                      <h6 className="mb-0  semi-bold text-black">Advantages and Opportunities</h6>
                    </AccordionSummary>
                    <AccordionDetails>
                      <p className="f-13 text-black">{business?.advantage_and_oppurtunity}</p>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion className="info-acc">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel3-content"
                      id="panel3-header"
                    >
                      <h6 className="mb-0  semi-bold text-black">Valuation</h6>
                    </AccordionSummary>
                    <AccordionDetails>
                      <p className="f-13 text-black">{business?.valuation}</p>
                    </AccordionDetails>
                  </Accordion>
                </div>
              </div>

              <div className="row contact-row mt-4">
                <div className="col-12 col-lg-8">
                  <div className="white-box finance-wrap ">
                    <h5 className="text-center text-black mb-4">About the Owner</h5>
                    <div className="row align-items-center">
                      <div className="col-12 col-md-6">
                        <img src={cnt} className="contact-info-ico" />
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="owner-contnet text-center">
                          <h5 className="pink">{business?.owner_name}</h5>
                          <p className="f-14">
                            <span className="d-block semi-bold">{business?.company}</span>
                            <span className="d-block ">Telephone : {business?.telephone}</span>
                            <span className="d-block">Mobile : {business?.phone}</span>
                            <span className="d-block semi-bold">Email:{business?.email}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-4">
                  <div className="various-info white-box finance-wrap mt-4">
                    <h5 className="text-center text-black mb-4">Various information</h5>
                    <div className="varous-box">
                      <div className="varoius-left">
                        <img src={info} />
                        <p className="text-black mb-0 f-14">Turnover 2023</p>
                      </div>
                      <p className="text-black various-rght mb-0 f-14">
                        {localSymbol}{' '}
                        {formatAmount(formatPrice(business?.turnover_last_year * localAmount))}
                      </p>
                    </div>
                    <div className="varous-box">
                      <div className="varoius-left">
                        <img src={info} />
                        <p className="text-black mb-0 f-14">Public orders</p>
                      </div>
                      <p className="text-black various-rght mb-0 f-14">{business?.public_order}</p>
                    </div>
                    <div className="varous-box">
                      <div className="varoius-left">
                        <img src={info} />
                        <p className="text-black mb-0 f-14">Company</p>
                      </div>
                      <p className="text-black various-rght mb-0 f-14">{business?.company_name}</p>
                    </div>
                    <div className="varous-box">
                      <div className="varoius-left">
                        <img src={info} />
                        <p className="text-black mb-0 f-14">Public orders</p>
                      </div>
                      <p className="text-black various-rght mb-0 f-14">{business?.public_order}</p>
                    </div>
                    <div className="varous-box">
                      <div className="varoius-left">
                        <img src={info} />
                        <p className="text-black mb-0 f-14">Available attachments</p>
                      </div>
                      <p className="text-black various-rght mb-0 f-14">
                        {business?.avaiable_attachment}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className=" container">
            <div className="row">
              <div className="col-12 col-lg-8">
                <h6 className="f-18 mt-4">Location:</h6>
                <div className="map">
                  <div
                    className="map-img-right bg-white rounded-10 shadow p-2"
                    style={{ height: '300px', width: '100%' }}
                  >
                    <GoogleMapReact
                      bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY }}
                      defaultCenter={{ lat: iLat, lng: iLong }}
                      defaultZoom={13}
                    >
                      <AnyReactComponent
                        lat={iLat}
                        lng={iLong}
                        text={<i className="fa-sharp fa-solid fa-location-dot googleEarth"></i>}
                      />
                    </GoogleMapReact>
                  </div>
                </div>
                <div className="location-box flex gap-2 mt-4 mb-5 items-center">
                  <img src={loc} className="loc-icon" />
                  <div className="loc-content">
                    <p className="f-14 light-color">
                      {business?.floor ?? ''} {business?.floor && ','} {business?.landmark ?? ''}
                      {business?.landmark && ','} {business?.location}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-lg-4">
                <div className="various-info shareholder white-box finance-wrap mt-4">
                  <h5 className="text-black mb-3">Shareholder</h5>
                  <div className="varous-box border-0">
                    <div className="varoius-left">
                      <p className="txt-gray mb-0 f-14">Name</p>
                    </div>
                    <p className="text-black various-rght mb-0 semi-bold f-14">
                      {business?.shareholder_name ?? 'NA'}
                    </p>
                  </div>
                  <div className="varous-box border-0">
                    <div className="varoius-left">
                      <p className="txt-gray mb-0 f-14">Share</p>
                    </div>
                    <p className="text-black various-rght mb-0 semi-bold f-14">
                      {localSymbol}{' '}
                      {formatAmount(formatPrice(business?.shareholder_share * localAmount)) ?? 'NA'}
                    </p>
                  </div>

                  <div className="mt-3">
                    <h6 className="text-black mb-2 semi-bold">Description</h6>
                    <p className="txt-gray">{business?.shareholder_description ?? 'NA'}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* {business?.customer_id !== user?.customer_id && (
            <div className="chat-icon">
              <div onClick={() => handleChat()} className="chat-button-fix pointer">
                <img src={chat1} className="chat-fil" />
              </div>
            </div>
          )} */}
          <SendMessage
            propType="bussiness_for_sale"
            propId={id}
            userId={business?.customer_id}
            fullData={business}
            show={show}
            isBusiness={true}
            invest={true}
            setShow={setShow}
            refetch={refetch}
          />
          <Footer />
        </ContentLayout>
      )}
    </>
  );
};
